<div class="video-container" [ngClass]="videoShape" [class.not-loaded]="!isLoaded" (click)="togglePlayPause()">
  @if (video || videoUrl) {
    <lib-video
      class="video-wrapper"
      [src]="video ? (video | videoPresign | async) : videoUrl"
      [hideControls]="true"
      [additionalOptions]="options"
    (videoDurationInitialized)="videoLoaded()"></lib-video>
  }

  @if (videoElement?.plyr?.paused && !hidePlayButton) {
    <button mat-icon-button class="play-button" aria-label="Play video" [ngClass]="theme">
      <lib-icon icon="play"></lib-icon>
    </button>
  }

  @if (!isLoaded) {
    <lib-skeleton-loader height="100%" width="100%"></lib-skeleton-loader>
  }
</div>
